import { render, staticRenderFns } from "./settings-user-org-edit.vue?vue&type=template&id=7cc2f376&"
import script from "./settings-user-org-edit.vue?vue&type=script&lang=js&"
export * from "./settings-user-org-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports